import { useEffect } from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

interface ToastProps {
  message: string;
  type: 'success' | 'error';
  onClose: () => void;
  duration?: number;
}

export function Toast({ message, type, onClose, duration = 3000 }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <div 
      className="fixed bottom-6 left-1/2 z-[9999] pointer-events-none"
      style={{ 
        transform: 'translateX(-50%)',
        animation: 'slideUpCentered 0.4s cubic-bezier(0.16, 1, 0.3, 1)'
      }}
    >
      <div
        className={`flex items-center gap-2 px-6 py-3 rounded-full shadow-lg pointer-events-auto ${
          type === 'success'
            ? 'bg-gradient-to-r from-primary to-primary-dark text-white'
            : 'bg-red-500 text-white'
        }`}
      >
        {type === 'success' ? (
          <CheckCircle2 className="w-5 h-5 flex-shrink-0" />
        ) : (
          <XCircle className="w-5 h-5 flex-shrink-0" />
        )}
        <span className="text-sm font-semibold whitespace-nowrap">{message}</span>
      </div>
    </div>
  );
}

